/**
 * coachPill — the one look every bottom-centre coach pill shares
 * (SelectFirstTip, ResizePrecisionTip). Extracted when the pills moved off
 * raw <div>s so the two can't drift apart again.
 */
import { css } from "react-strict-dom";
import { colors } from "@duro-app/tokens/tokens/colors.css";
import { spacing, radii } from "@duro-app/tokens/tokens/spacing.css";
import { borders } from "@duro-app/tokens/tokens/borders.css";
import { typography, typeScale } from "@duro-app/tokens/tokens/typography.css";
import { shadows } from "@duro-app/tokens/tokens/shadows.css";
import { layers } from "@duro-app/tokens/tokens/layers.css";

export const coachPill = css.create({
  pill: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: layers.floating,
    display: "flex",
    alignItems: "center",
    gap: spacing.ms,
    maxWidth: "calc(100% - 2rem)",
    paddingTop: spacing.sm,
    paddingBottom: spacing.sm,
    paddingLeft: "1rem",
    paddingRight: "0.75rem",
    borderRadius: "0.75rem",
    backgroundColor: colors.contrastSurface,
    color: colors.onContrastSurface,
    fontSize: typeScale.fontSize2,
    lineHeight: 1.3,
    boxShadow: shadows.lg,
    // The pill floats over the canvas, often right over the block the person
    // just selected: let presses fall through to it. Only "Got it" takes them.
    pointerEvents: "none",
  },
  dismiss: {
    flexShrink: 0,
    pointerEvents: "auto",
    paddingTop: "0.25rem",
    paddingBottom: "0.25rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    borderRadius: radii.full,
    borderWidth: borders.hairline,
    borderStyle: "solid",
    borderColor: colors.contrastBorder,
    backgroundColor: "transparent",
    color: colors.onContrastSurface,
    fontSize: typography.fontSizeXs,
    fontWeight: typography.fontWeightSemibold,
    cursor: "pointer",
  },
});
